export const VIEWPORT_SNAPSHOT_EVENT = 'ViewportSnapshot';

export const RESIZE_DEBOUNCE_MS = 500;
export const MAX_RESIZE_EVENTS_PER_PAGE_LOAD = 20;

// Mirrors apps/root/client/styles/css/abstracts/variables.scss (min-width, CSS px)
export const LAYOUT_BREAKPOINTS: Array<{ name: string; minWidth: number }> = [
    { name: 'xxxl', minWidth: 1600 },
    { name: 'xxl', minWidth: 1440 },
    { name: 'xl', minWidth: 1200 },
    { name: 'lg', minWidth: 992 },
    { name: 'md', minWidth: 768 },
    { name: 'sm', minWidth: 576 },
];
export const SMALLEST_BREAKPOINT_NAME = 'xs';

// Chromium's preset page zoom levels
export const CHROMIUM_ZOOM_LEVELS = [
    0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3,
    4, 5,
];

// Windows display scale settings (2 also covers macOS Retina)
export const OS_SCALE_LEVELS = [1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 3, 3.5];

// Relative tolerance when snapping a measured ratio to a known level
export const SCALE_SNAP_TOLERANCE = 0.03;

// Allows for window borders when deciding if a window is maximised
export const MAXIMISED_TOLERANCE_PX = 16;

export const COMMON_PHYSICAL_SCREEN_WIDTHS = [
    1280, 1360, 1366, 1440, 1536, 1600, 1680, 1920, 2048, 2160, 2256, 2560,
    2880, 3000, 3072, 3200, 3440, 3840, 5120,
];
export const PHYSICAL_WIDTH_TOLERANCE_PX = 2;
